var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-center col-5"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.clickSaveButton()}}},[_vm._v("設定を保存")])])}
var staticRenderFns = []

export { render, staticRenderFns }